export default {
  psdSieveAnalysis: {
    AS_1289_3_6_3: '11021',
    AS_1141_11_1: { rev2020: '110518' },
    AS_1289_3_6_1: {
      RevOriginal: '10022',
      RevOriginal2: '10024',
      Reduced: '10437',
      Rev2009: '110519',
    },
  },
  atterbergLimit: {
    AS_1289_3_1_1or3_2_1or3_3_1: { rev2009: '110472' }, //Four Point
    AS_1289_3_1_2or3_2_1or3_3_1: { rev2009: '110475' }, //One Point
    AS_1289_3_1_1or3_2_1or3_3_1or3_4_1: { rev2009: '110498' }, //Four Point with shrinkage
    AS_1289_3_1_2or3_2_1or3_3_1or3_4_1: { rev2009: '110499' }, //One Point with shrinkage
  },
  liquidLimit: {
    AS_1289_3_1_1_LiquidLimit: { rev2009: '110473' },
    AS_1289_3_1_2_LiquidLimit: { rev2009: '110496' },
  },
  convertedWetDensity: {
    AS_1289_5_7_1: { rev2006: '11700' },
  },
  linearShrinkage: {
    AS_1289_5_4_1: { rev2008: '110488' },
  },
  maximumDryDensity: {
    AS_1289_5_1_1: { rev2017: '10138' },
    AS_1289_5_2_1: { rev2017: '10139' },
  },
  oversizeDetermination: { AS_1289_5_1_1: '110476' },
  moistureContent: {
    AS_1289_2_1_1: { rev2005: '11630' },
    AS_1289_2_1_2: { rev2005: '11631' },
    AS_1289_2_1_4: { rev2005: '11632' },
    AS_1289_2_1_5: { rev2005: '11633' },
    AS_1289_2_1_6: { rev2005: '11634' },
  },
  moistureCorrelation: {
    AS_1289_2_3_1: '11320',
  },
  relativeCompaction: {
    AS_1289_5_4_1: { rev2007: '110497' },
  },
  dynamicConePenetrometer: {
    AS_1289_6_3_2: { rev1997: '110515' },
  },
  emersonClassification: {
    AS_1289_3_8_1: { rev2017: '110516' },
  },
  nuclearFieldDensity: {
    AS_1289_5_8_1: { rev2007: '110514' },
  },
  assignedMaximumDryDensity: {
    AS_1289_5_4_2: { assignedValueTest: '110520', rev2007: '110517' },
  },
  binderContent: {
    AS_2891_3_2: { rev2013: '17555' },
  },
  bitumenContent: {
    AS_2891_3_1: '17015',
    AS_2891_3_3: '17010',
  },
  wash: {
    AS_1141_11_1: { rev2020: '110523' },
    AS_1289_3_6_1: { Rev2009: '110525' },
  },
};
